export default __webpack_public_path__ + "static/media/rebook-M.29f5f0a3.png";